import { BrandLogo } from "@/components/shared/BrandLogo";

import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-[var(--aur-border)] bg-[var(--aur-bg-2)]">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <BrandLogo size="h-16 w-16" text="text-3xl" subtitle="Hospitality Group · Singapore" />
            <p className="mt-4 max-w-sm font-sans text-sm leading-relaxed text-[var(--aur-text-2)]">
              An intimate collection of ultra-luxury hotels and resorts across Singapore's most storied
              addresses — Marina Bay, Sentosa, Orchard Road, and the historic Quay.
            </p>
          </div>
          <div>
            <p className="eyebrow mb-4">Discover</p>
            <ul className="space-y-3 font-sans text-sm text-[var(--aur-text-2)]">
              <li><Link to="/properties" className="hover:text-gold">Our Properties</Link></li>
              <li><Link to="/careers" className="hover:text-gold">Careers</Link></li>
              <li><Link to="/login" className="hover:text-gold">Candidate Portal</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-4">Contact</p>
            <ul className="space-y-3 font-sans text-sm text-[var(--aur-text-2)]">
              <li>reservations@aureliagroup.sg</li>
              <li>hr@aureliagroup.sg</li>
              <li>+65 6000 0000</li>
              <li>Marina Bay · Sentosa · Orchard · The Quay</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-[var(--aur-border)] pt-8 md:flex-row md:items-center">
          <p className="font-mono text-[10px] uppercase tracking-widest text-[var(--aur-text-2)]">
            © {new Date().getFullYear()} Aurelia Hospitality Group. All requests subject to manual confirmation.
          </p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="font-mono text-[10px] uppercase tracking-widest text-[var(--aur-text-2)] hover:text-gold">
            Staff Access
          </Link>
        </div>
      </div>
    </footer>
  );
}
